const $$splitComponentImporter = () => import('/home/runner/work/upple-client-v2/upple-client-v2/src/routes/auth/hr/setup-initial-password.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
export const Route = createFileRoute('/auth/hr/setup-initial-password')({
  validateSearch: search => ({
    code: search.code as string ?? '',
    // HR은 대상자 등록을 하러 초대되므로 비번 설정 직후 "내 할 일"로 바로 보낸다.
    redirect: search.redirect as string ?? '/hr/case-registration'
  }),
  component: lazyRouteComponent($$splitComponentImporter, 'component', () => Route.ssr)
});
export function TSRDummyComponent() {
  return null;
}